export const setSelection = objType => {
  return {
    type: 'SET_SELECTION',
    objType,
  };
};
